import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RocFilter } from '@main-application/dashboard-reports/roc-report/interfaces/roc-list-item';
import { RestTurnoverTaskModel } from '@shared/interfaces/turnover.interface';

import { TurnoversService } from './turnovers.service';

@Injectable({
  providedIn: 'root',
})
export class RocService {
  constructor(private restApiService: RestapiService) {}

  fetchReport(portfolioId: number, filter: RocFilter): Observable<RestTurnoverTaskModel[]> {
    return this.restApiService.getData<RestTurnoverTaskModel[]>(
      `turnovers/portfolio/${portfolioId}/underconstruction?begin=${moment(filter.beginDate).format(
        'YYYY-MM-DD'
      )}&end=${moment(filter.endDate).format('YYYY-MM-DD')}`,
      TurnoversService.fixTimezoneForTurnoverTaskModel
    );
  }

  updateMarketRent(turnoverId: number, marketRentOverride: number) {
    return this.restApiService.update(`turnovers/${turnoverId}/UpdateMarketRentOverride`, marketRentOverride);
  }

  updateConstructionCost(turnoverId: number, cost: number) {
    return this.restApiService.update(`turnovers/${turnoverId}/UpdateConstructionCost`, cost);
  }

  updateNewRent(turnoverId: number, newRent: number) {
    return this.restApiService.update(`turnovers/${turnoverId}/UpdateNewRentOverride`, newRent);
  }

  updateOldRent(turnoverId: number, oldRent: number) {
    return this.restApiService.update(`turnovers/${turnoverId}/UpdateOldRentOverride`, oldRent);
  }
}
